import { useEffect, useState } from "react";
import Shell from "../components/Shell";
import { api } from "../lib/api";

export default function Analytics() {
  const [kpi, setKpi] = useState(null);

  useEffect(() => { api.get("/dashboard/kpis").then((r) => setKpi(r.data)); }, []);

  if (!kpi) return <Shell><div className="p-12 label-xs">Loading...</div></Shell>;
  const sources = kpi.source_breakdown || [];

  return (
    <Shell>
      <div className="p-4 sm:p-8 max-w-6xl" data-testid="analytics-page">
        <div className="label-xs text-amber">&gt; LEAD_SOURCE_ANALYTICS</div>
        <h1 className="font-display text-3xl sm:text-5xl leading-none mt-2">Analytics.</h1>
        <p className="mt-2 text-fg-muted font-mono text-sm">ROI by lead source · what&apos;s paying for itself.</p>

        {sources.length === 0 ? (
          <div className="mt-12 border border-term bg-raised p-12 text-center">
            <div className="font-display text-2xl text-fg-muted">No source data yet.</div>
            <div className="text-xs text-fg-subtle mt-2 font-mono uppercase tracking-widest">Add &apos;source&apos; on leads to see ROI breakdown.</div>
          </div>
        ) : (
          <div className="mt-8 border border-term bg-raised overflow-x-auto">
            <div className="min-w-[640px]">
            <div className="grid grid-cols-6 gap-2 px-4 py-3 border-b border-term label-xs">
              <div>SOURCE</div><div className="text-right">LEADS</div><div className="text-right">CLOSED</div><div className="text-right">CLOSE %</div><div className="text-right">SPEND</div><div className="text-right">ROI</div>
            </div>
            {sources.sort((a, b) => b.roi - a.roi).map((s) => (
              <div key={s.source} className="tap-row grid grid-cols-6 gap-2 px-4 py-3 text-sm font-mono">
                <div className="font-bold text-fg">{s.source}</div>
                <div className="text-right text-fg-muted">{s.leads}</div>
                <div className="text-right text-gain">{s.closed}</div>
                <div className="text-right text-fg-muted">{s.close_rate}%</div>
                <div className="text-right text-fg-muted">${s.cost.toLocaleString()}</div>
                <div className={`text-right font-bold ${s.roi >= 0 ? "text-gain" : "text-live"}`}>{s.roi >= 0 ? "+" : ""}{s.roi}%</div>
              </div>
            ))}
            </div>
          </div>
        )}

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-px bg-term border border-term">
          <div className="bg-raised p-5">
            <div className="label-xs">AVG $/DIAL</div>
            <div className="font-display text-4xl mt-2 text-amber">${kpi.dollar_per_dial}</div>
          </div>
          <div className="bg-raised p-5">
            <div className="label-xs">AVG AI SCORE</div>
            <div className={`font-display text-4xl mt-2 ${kpi.avg_ai_score >= 70 ? "text-gain" : "text-warn"}`}>{kpi.avg_ai_score || "—"}</div>
          </div>
          <div className="bg-raised p-5">
            <div className="label-xs">CONNECT %</div>
            <div className="font-display text-4xl mt-2 text-electric">{kpi.connect_rate}%</div>
          </div>
        </div>
      </div>
    </Shell>
  );
}
